export default class Currency {
	code: string;

	constructor(code: string) {
		this.code = code;
	}
}
